import concat from 'lodash/concat';
import generalTabFields from '@/domain/data/generalPanel/reports/additionalFields/generalTabFields';
import transformerTabFields from '@/domain/data/generalPanel/reports/additionalFields/transformerTabFields';
import circuitBreakerTabFields from '@/domain/data/generalPanel/reports/additionalFields/circuitBreakerTabFields';
import disconnectorTabFields from '@/domain/data/generalPanel/reports/additionalFields/disconnectorTabFields';
import { getDeepestObjectsByProperty } from '@/services/objectHelpers';

export default (vm) => {
  const allAdditionalFields = concat(
    generalTabFields(vm),
    transformerTabFields(vm),
    circuitBreakerTabFields(vm),
    disconnectorTabFields(vm),
  );
  return getDeepestObjectsByProperty(allAdditionalFields, 'text');
};
